import { render, staticRenderFns } from "./artefact-card.vue?vue&type=template&id=1c20661c&scoped=true&"
import script from "./artefact-card.vue?vue&type=script&lang=ts&"
export * from "./artefact-card.vue?vue&type=script&lang=ts&"
import style0 from "./artefact-card.vue?vue&type=style&index=0&id=1c20661c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20661c",
  null
  
)

export default component.exports